import React, { useEffect, useState } from 'react';

import './SubscribePage.css';

import tgIcon from './../../images/tg.svg';
import helpIcon from './../../images/q-icon.svg';
import axios from 'axios';

const SubscribePage = ({
    setCurrentPage,
    channelLink,
    loadingCategories,
    translations,
    userLang,
}) => {
    const [intervalLink, setIntervalLink] = useState(null);
    const [timeoutLink, setTimeoutLink] = useState(null);

    useEffect(() => {
        return () => {
            if (intervalLink) {
                clearInterval(intervalLink);
            }
            if (timeoutLink) {
                clearTimeout(timeoutLink);
            }
        };
    }, [intervalLink, timeoutLink]);

    const handleSubscribeLink = () => {
        const subscribeInterval = setInterval(async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/channel/subscribe/check',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                            'Accept-Language': userLang,
                        },
                    }
                );
                console.log(response.data.result);
                if (response.data.result === true) {
                    clearInterval(subscribeInterval);
                    if (timeoutLink) {
                        clearTimeout(timeoutLink);
                    }
                    loadingCategories();
                    setCurrentPage('MapPage');
                }
            } catch (error) {
                console.error('Ошибка проверки подписки ', error);
            }
        }, 1000);

        setIntervalLink(subscribeInterval);

        const subscribeTimeout = setTimeout(() => {
            clearInterval(subscribeInterval);
            alert(translations.subAlert);
        }, 30000);

        setTimeoutLink(subscribeTimeout);
    };

    return (
        <div className='subscribe__page'>
            <a
                href={channelLink}
                target='_blank'
                rel='noopener'
                className='subscribe__button'
                onClick={handleSubscribeLink}
            >
                {translations.subscribe}
                <img src={tgIcon} alt='subscribe' width='24px' />
            </a>
            <div className='subscribe__block'>
                <div className='subscribe__help'>
                    <button>
                        <img src={helpIcon} alt='help' />
                        {translations.work}
                    </button>
                </div>
                <div className='subscribe__info'>
                    <p>{translations.MePoint}</p>
                    <p>{translations.MePoint2}</p>
                </div>
            </div>
        </div>
    );
};

export default SubscribePage;
